import { useEffect, useState } from "react";
import { getClients, getTasks, getJobs, getPosts } from "./opsApi";
import { Users, CheckSquare, Film, CalendarClock } from "lucide-react";

const Card = ({ icon: Icon, label, value, testId }) => (
  <div data-testid={testId} className="rounded-2xl border border-white/10 bg-[#241010] p-5">
    <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-white/50"><Icon className="h-4 w-4" /> {label}</div>
    <div className="mt-2 font-serif text-3xl font-bold text-white">{value}</div>
  </div>
);

export default function OpsDashboard() {
  const [s, setS] = useState({ clients: 0, tasks: 0, jobs: 0, posts: 0 });
  useEffect(() => {
    Promise.all([getClients(), getTasks(), getJobs(), getPosts()])
      .then(([c, t, j, p]) => setS({ clients: c.length, tasks: t.filter((x) => x.status !== "hecho").length, jobs: j.length, posts: p.filter((x) => x.status === "scheduled").length }))
      .catch(() => {});
  }, []);
  return (
    <div data-testid="ops-dashboard">
      <h2 className="mb-5 font-serif text-2xl font-bold text-white">Resumen</h2>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Card icon={Users} label="Clientes" value={s.clients} testId="ops-stat-clients" />
        <Card icon={CheckSquare} label="Tareas abiertas" value={s.tasks} testId="ops-stat-tasks" />
        <Card icon={Film} label="Videos" value={s.jobs} testId="ops-stat-jobs" />
        <Card icon={CalendarClock} label="Posts programados" value={s.posts} testId="ops-stat-posts" />
      </div>
    </div>
  );
}
